import { AnyAction } from "redux";
import { CREATE_SUPPORT_TICKET_FAILURE, CREATE_SUPPORT_TICKET_REQUEST, CREATE_SUPPORT_TICKET_SUCCESS, GET_SUPPORT_TICKET_DETAIL_FAILURE, GET_SUPPORT_TICKET_DETAIL_REQUEST, GET_SUPPORT_TICKET_DETAIL_SUCCESS, GET_SUPPORT_TICKET_FAILURE, GET_SUPPORT_TICKET_REQUEST, GET_SUPPORT_TICKET_SUCCESS, POST_SUPPORT_TICKET_COMMENT_REQUEST, POST_SUPPORT_TICKET_COMMENT_FAILURE, POST_SUPPORT_TICKET_COMMENT_SUCCESS, UPDATE_SUPPORT_TICKET_STATUS_REQUEST, UPDATE_SUPPORT_TICKET_STATUS_SUCCESS, UPDATE_SUPPORT_TICKET_STATUS_FAILURE } from "../constants/support-ticket.constants";

const initialState = {
    loading: false,
    data: [],
    ticketDetail: null,
    error: "",
    count: 0,
    createdSupportTicket: {
        loading: false,
        data: [],
        error: "",
    },
};

export const supportTicketReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case GET_SUPPORT_TICKET_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_SUPPORT_TICKET_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload?.data ?? action.payload ?? [],
                count: action.payload?.count ?? 0,
                error: "",
            };
        case GET_SUPPORT_TICKET_FAILURE:
            return {
                ...state,
                loading: false,
                data: [],
                count: 0,
                error: action.payload,
            };

        case CREATE_SUPPORT_TICKET_REQUEST:
            return {
                ...state,
                createdSupportTicket: {
                    loading: true,
                    data: [],
                    error: "",
                },
            };

        case CREATE_SUPPORT_TICKET_SUCCESS:
            return {
                ...state,
                createdSupportTicket: {
                    loading: false,
                    data: action.payload,
                    error: "",
                },
            };

        case CREATE_SUPPORT_TICKET_FAILURE:
            return {
                ...state,
                createdSupportTicket: {
                    loading: false,
                    data: [],
                    error: action.payload,
                },
            };

        case GET_SUPPORT_TICKET_DETAIL_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_SUPPORT_TICKET_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                ticketDetail: action.payload,
                error: "",
            };
        case GET_SUPPORT_TICKET_DETAIL_FAILURE:
            return {
                ...state,
                loading: false,
                ticketDetail: null,
                error: action.payload,
            };

        case POST_SUPPORT_TICKET_COMMENT_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case POST_SUPPORT_TICKET_COMMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                error: "",
            };

        case POST_SUPPORT_TICKET_COMMENT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case UPDATE_SUPPORT_TICKET_STATUS_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case UPDATE_SUPPORT_TICKET_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: "",
            };

        case UPDATE_SUPPORT_TICKET_STATUS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};
